import { CONFLICT_BILLING_INSTRUCTIONS_FIELD } from '../constants/conflictFieldConstants';
import type { ConflictResultRow } from '../models/conflictTypes';

/**
 * A matched value is the field's content, so a row on a gated field discloses it just
 * as the preview would. Applied to a live check and to a saved one alike.
 *
 * Rows are dropped whole, not trimmed: removing just the gated field would hide its
 * text, but the row's tier and word counts would still reflect it, so a viewer could
 * infer the billing instructions matched in full. The frontend can only withhold what
 * it is sent — the scan should not return these rows without the permission.
 */
export function withoutGatedRows(
  rows: ConflictResultRow[],
  canSeeBillingInstructions: boolean,
): ConflictResultRow[] {
  if (canSeeBillingInstructions) return rows;
  return rows.filter(
    (row) =>
      !row.fields.some(
        (field) => field.id === CONFLICT_BILLING_INSTRUCTIONS_FIELD,
      ),
  );
}
